import { IPublicationDetailResponse } from "../../../model/base/response/publication-response";

export type PublicationDetailState = {
  detail: IPublicationDetailResponse | null;
  loading: boolean;
  error: string | null;
};

export enum ACTION_TYPES {
  loadingDetail = 'loadingDetail',
  setLoading = 'setLoading',
  setError = 'setError',
  clearData = 'clearData'
}

export type PublicationDetailAction = {
  type: ACTION_TYPES;
  payload?: any;
};

export const initialState: PublicationDetailState = {
  detail: null,
  loading: true,
  error: null,
};

export const PublicationDetailReducer = (
  state: PublicationDetailState,
  action: PublicationDetailAction
): PublicationDetailState => {
  switch (action.type) {
    case ACTION_TYPES.loadingDetail:
      return {
        ...state,
        detail: action.payload,
        loading: false,
        error: null,
      };
    case ACTION_TYPES.setLoading:
      return {
        ...state,
        loading: action.payload,
      };
    case ACTION_TYPES.setError:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case ACTION_TYPES.clearData:
      return initialState;
    default:
      return state;
  }
};
